export default "__VITE_ASSET__BVxvdsSo__"